export const SUBSCRIPTION_ENABLED = 'subscription.enabled';
export const SUBSCRIPTION_PAIRING_PAYMENT_ENABLED =
  'web.subscription.pairing.payment.enabled';
